import api from './auth';

const BASE_URL = '/api/admin/feedback';

export const adminFeedbackAPI = {
    // Get all feedback with filtering and pagination
    getAllFeedback: (page = 0, size = 10, status = '', search = '', feedbackType = '') => {
        const params = new URLSearchParams({
            page: page.toString(),
            size: size.toString(),
            sort: 'createdAt,desc'
        });

        if (status) params.append('status', status);
        if (search) params.append('search', search);
        if (feedbackType) params.append('feedbackType', feedbackType);

        return api.get(`${BASE_URL}?${params}`);
    },

    // Get detailed feedback with image information
    getFeedbackDetails: (feedbackId) => {
        return api.get(`${BASE_URL}/${feedbackId}`);
    },

    // Resolve feedback with admin response
    resolveFeedback: (feedbackId, adminResponse) => {
        return api.put(`${BASE_URL}/${feedbackId}/resolve`, adminResponse, {
            headers: {
                'Content-Type': 'text/plain'
            }
        });
    },

    // Update feedback status
    updateFeedbackStatus: (feedbackId, status) => {
        return api.put(`${BASE_URL}/${feedbackId}/status`, null, {
            params: { status }
        });
    },

    // Export incorrect feedback for AI training
    exportIncorrectFeedback: () => {
        return api.get(`${BASE_URL}/export/incorrect`, {
            responseType: 'blob',
            headers: {
                'Accept': 'application/json'
            }
        });
    },

    // Export high-priority incorrect feedback
    exportHighPriorityFeedback: () => {
        return api.get(`${BASE_URL}/export/high-priority`, {
            responseType: 'blob',
            headers: {
                'Accept': 'application/json'
            }
        });
    },

    // Export all feedback data
    exportAllFeedback: () => {
        return api.get(`${BASE_URL}/export/all`, {
            responseType: 'blob',
            headers: {
                'Accept': 'application/json'
            }
        });
    },

    // Get image URL for classification - Fixed to use correct static resource endpoint
    getClassificationImageUrl: (filename) => {
        return `${process.env.REACT_APP_API_URL || 'http://localhost:8081'}/uploads/waste/${filename}`;
    },

    // Get feedback statistics for admin dashboard
    getFeedbackStats: () => {
        return api.get('/api/admin/stats/feedback-analytics');
    }
};

export default adminFeedbackAPI;
